'use strict';

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var classnames = require('classnames');
var index = require('../store/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

var WizardStep = function WizardStep(_ref) {
  var children = _ref.children,
      className = _ref.className,
      description = _ref.description,
      index$1 = _ref.index,
      title = _ref.title;

  var _useContext = React.useContext(index.default),
      handleWizardSubmit = _useContext.handleWizardSubmit,
      steps = _useContext.steps;

  var step = index$1 + 1;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classnames__default['default']('ds-organisms-wizard-step', _rollupPluginBabelHelpers.defineProperty({}, className, !!className))
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-wizard-step-index"
  }, "Step ".concat(step)), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-wizard-step-title"
  }, "".concat(step, ". ").concat(title)), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-wizard-step-description"
  }, description), React.cloneElement(children, {
    handleWizardSubmit: handleWizardSubmit,
    formRef: steps[index$1].formRef
  }));
};

WizardStep.propTypes = {
  children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].node), PropTypes__default['default'].node]).isRequired,
  className: PropTypes__default['default'].string,
  description: PropTypes__default['default'].string.isRequired,
  index: PropTypes__default['default'].number,
  title: PropTypes__default['default'].string.isRequired
};
WizardStep.defaultProps = {
  className: undefined,
  index: undefined
};

module.exports = WizardStep;
